import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import QuestionMarkIcon from './assets/questionMarkCircle.svg?react';
import CloseIcon from './assets/multiply.svg?react';

export const Container = styled.div`
    width: 100%;
    height: 48px;
    background-color: var(--blue100);
`;

export const TitleBar = styled.button`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 48px;
    background-color: var(--blue100);
    font-size: 16px;
    line-height: 24px;
    font-weight: 600;
    color: var(--blue700);
    padding: 0 16px;
    outline: none;
    border: none;
    fill: var(--blue700);
    cursor: pointer;

    & > svg {
        width: 18px;
        height: 18px;
        pointer-events: none;
    }

    &:active {
        background-color: var(--blue200);
    }
`;

export const Body = styled.div`
    background-color: var(--gray50);
    box-shadow: var(--shadow-2);
    padding: 0 16px;

    & > div:not(:last-child) {
        border-bottom: 1px solid var(--gray200);
    }
`;

const StatusBar = ({ children }) => {
    const [opened, setOpened] = useState(false);
    const containerRef = useRef();

    useEffect(() => {
        document.addEventListener('click', handleClick);
        return () => {
            document.removeEventListener('click', handleClick);
        };
    }, []);

    const handleClick = (e) => {
        if (!containerRef.current.contains(e.target)) {
            setOpened(false);
        }
    };

    return (
        <Container ref={containerRef}>
            <TitleBar onClick={() => setOpened(!opened)}>
                <span>{'Informazioni utili'}</span>
                {opened ? <CloseIcon /> : <QuestionMarkIcon />}
            </TitleBar>
            {opened && <Body>{children}</Body>}
        </Container>
    );
};

StatusBar.propTypes = {
    children: PropTypes.node,
};

export default StatusBar;
